import styled, {css} from "styled-components"

import Flex from "@irati/ui/src/Flex"
import Button from "@irati/ui/src/Button"
import {Body, H2} from "@irati/ui/src/Typography"

interface Props {
  isExternalPage?: boolean
}

export const labelCss = css`
  user-select: none;
  cursor: pointer;

  &:active,
  &:hover {
    outline: none;
  }
`

export const SubmitButton = styled(Button)`
  align-self: flex-end;
`

export const flexTypesetCss = css<Props>`
  ${({isExternalPage, theme}) => css`
    flex-basis: 60%;

    ${theme.mediaQueries.minWidthMedia.tablet`
      flex-basis: ${isExternalPage ? "75%" : "65%"};
    `}
  `}
`

export const FlexBody = styled(Body)`
  ${flexTypesetCss}
`

export const FlexH2 = styled(H2)<Props>`
  ${flexTypesetCss}
`

export const LabelWrapper = styled(Flex)<Props>`
  width: 35%;
  margin-left: auto;
  justify-content: flex-end;

  ${({isExternalPage, theme}) => theme.mediaQueries.minWidthMedia.tablet`
    width: ${isExternalPage ? "20%" : "30%"};
  `}

  ${({isExternalPage, theme}) => theme.mediaQueries.minWidthMedia.desktop`
    width: ${isExternalPage ? "17%" : "25%"};
  `}
`

export const ToggleWrapper = styled(Flex)<Props>`
  margin-right: ${({theme}) => theme.spacing.one};
  justify-content: flex-end;
  flex-basis: 35%;

  ${({isExternalPage, theme}) => theme.mediaQueries.minWidthMedia.tablet`
    flex-basis: ${isExternalPage ? "20%" : "30%"};
  `}

  ${({isExternalPage, theme}) => theme.mediaQueries.minWidthMedia.desktop`
    flex-basis: ${isExternalPage ? "17%" : "25%"};
  `}
`

export const EmailLabel = styled(Flex).attrs(() => ({
  tabIndex: 0
}))`
  ${labelCss}
  margin-right: ${({theme}) => theme.spacing.two};
`
